"use strict";

exports.__esModule = true;
exports.default = void 0;
var _listCacheClear = _interopRequireDefault(require("./_listCacheClear.js"));
var _listCacheDelete = _interopRequireDefault(require("./_listCacheDelete.js"));
var _listCacheGet = _interopRequireDefault(require("./_listCacheGet.js"));
var _listCacheHas = _interopRequireDefault(require("./_listCacheHas.js"));
var _listCacheSet = _interopRequireDefault(require("./_listCacheSet.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear.default;
ListCache.prototype['delete'] = _listCacheDelete.default;
ListCache.prototype.get = _listCacheGet.default;
ListCache.prototype.has = _listCacheHas.default;
ListCache.prototype.set = _listCacheSet.default;
var _default = exports.default = ListCache;